import React from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './styles.css';

/**
 * This component is wrapped around other components to give them a faded transition.
 * In order to use it, you must include a TransitionGroup tag immediately before it.
 * Props are injected from TransitionGroup and passed directly
 * into CSSTransition from here.
 */
export const FadeTransition = ({ ...props }) => (
	<CSSTransition
		{...props}
		timeout={500}
		appear
		classNames={{
			enter: styles.enter,
			enterActive: styles['enter-active'],
			exit: styles.exit,
			exitActive: styles['exit-active'],
			appear: styles.appear,
			appearActive: styles['appear-active'],
		}}
	/>
);

